import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const next = params.get("next") || "/workspace";
    const run = async () => {
      // supabase-js with detectSessionInUrl=true handles both PKCE & hash flows
      // automatically. We just wait briefly then route to `next`.
      try {
        const code = params.get("code");
        if (code) {
          await supabase.auth.exchangeCodeForSession(window.location.href);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[auth] exchange failed", e?.message);
      }
      navigate(next, { replace: true });
    };
    run();
  }, [navigate, params]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
}
